import { useEffect, useState } from 'react';
import { Participant, RemoteParticipant } from 'twilio-video';
import { getParticipantType } from '../services/participant.service';
import { ParticipantType } from '../types/participant.type';

export interface UseParticipantTypeOptions {
    participants: RemoteParticipant[];
    requestId: string | null;
}
export interface UseParticipantTypeResult {
    participantTypeMap: Map<Participant.Identity, ParticipantType>;
}

export default function useParticipantType({
    participants,
    requestId,
}: UseParticipantTypeOptions): UseParticipantTypeResult {
    const [participantTypeMap, setParticipantTypeMap] = useState<
        Map<Participant.Identity, ParticipantType>
    >(new Map());
    const fetchParticipantType = async (participantId: Participant.Identity) => {
        if (requestId && participantId) {
            const { data } = await getParticipantType({ requestId, participantId });
            if (data) {
                setParticipantTypeMap((oldParticipantTypeMap) => {
                    const newParticipantTypeMap = new Map(oldParticipantTypeMap);
                    newParticipantTypeMap.set(participantId, data.participantType);

                    return newParticipantTypeMap;
                });
            }
        }
    };

    useEffect(() => {
        setParticipantTypeMap(new Map());
        participants.forEach((participant) => {
            const timeoutId = setTimeout(() => {
                fetchParticipantType(participant.identity);
                clearTimeout(timeoutId);
            }, 2000);
        });
    }, [participants]);

    return {
        participantTypeMap,
    };
}
